import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LaravelResourceResponse } from '../../../../../../_base-shared/contracts/laravel-response.interface';
import { PickedFile } from '../../../../../../_base-shared/models/File/AppFile';
import { CaseCreditorService } from '../../case/case-creditor.service';
import { finalize } from 'rxjs/operators';
import { Creditor } from 'projects/_base-shared/models/Entity/Creditor';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector:    'app-creditor-import-v2',
  templateUrl: './creditor-import-v2.component.html',
  styleUrls:   ['./creditor-import-v2.component.scss'],
})
export class CreditorImportV2Component implements OnInit {
  public form: UntypedFormGroup;
  public isLoading                      = 0;
  public isSubmitting                   = 0;
  public pickedFiles: Array<PickedFile> = [];
  public serverResponse: LaravelResourceResponse;

  constructor(
    private toast: ToastrService,
    private fb: UntypedFormBuilder,
    protected router: Router,
    private translateService: TranslateService,
    private caseCreditorService: CaseCreditorService) {
  }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.form = this.fb.group({
      file: [null],
    });
  }

  public submitForm(): void {
    const formData = new FormData();
    formData.append('file', this.pickedFiles[0].file, this.pickedFiles[0].name + '.' + this.pickedFiles[0].extension);

    this.serverResponse = null;
    this.isLoading++;
    this.caseCreditorService.caseCreditorCSVUpdate(formData)
      .pipe(finalize(() => this.isLoading--))
      .subscribe((result: any) => {
        this.toast.success(this.translateService.instant('SHARED.success'));
        if (Object.keys(result.errors).length) {
          this.serverResponse = result;
        }
      }, (err) => {
        this.serverResponse = err.error;
        this.toast.error(err.error.message);
      });
  }

  public onAttachmentsChange($event): void {
    const fileList: FileList = ($event.target as HTMLInputElement).files;
    for (let i = 0; i < fileList.length; i++) {
      const file      = fileList[i];
      const fileName  = file.name;
      const lastDot   = fileName.lastIndexOf('.');
      const name      = fileName.substring(0, lastDot);
      const extension = fileName.substring(lastDot + 1);
      this.pickedFiles.push({name, extension, type: file.type, size: file.size, file});
    }
  }

  public removeLocalAttachment(index: any): void {
    this.pickedFiles.splice(index, 1);
  }
}
